import { render, staticRenderFns } from "./CarMain.vue?vue&type=template&id=104084ca&scoped=true&"
import script from "./CarMain.vue?vue&type=script&lang=js&"
export * from "./CarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104084ca",
  null
  
)

export default component.exports